<template>
<div class="h-100 d-block d-lg-none">
<nav class="navbar navbar-expand-lg navbar-light bg-white  shadow-sm w-100">
    


    <div  class="collapse navbar-collapse show">
      <ul class="navbar-nav mr-auto">
           <li v-for="category in $page.props.categories" :key="category.id" class="nav-item dropdown">
                <a v-if="category.children" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true">
                    {{category.category_name}}

                </a>

                 <inertia-link v-else :href="this.route('products',{id:category.id})">
                    {{category.category_name}}

                </inertia-link>
                
            
                <ul v-if="category.children" class="dropdown-menu border-0 shadow">
                    <li v-for="child in category.children" :key="child.id" class="dropdown-submenu">

                        <a v-if="child.children" class="dropdown-item dropdown-toggle" data-toggle="dropdown" aria-haspopup="true">
                            {{child.category_name}}

                        </a>

                        <inertia-link v-else :href="this.route('products',{id:child.id})" >
                            {{child.category_name}}

                        </inertia-link>

                        <ul v-if="child.children" class="dropdown-menu border-0 shadow">
                            <li v-for="child2 in child.children" :key="child2.id" class="dropdown-submenu">


                               <a v-if="child2.children" class="dropdown-item dropdown-toggle" data-toggle="dropdown" aria-haspopup="true">
                                        {{child2.category_name}}

                                    </a>

                                    <inertia-link v-else :href="this.route('products',{id:child2.id})" >
                                        {{child2.category_name}}

                                </inertia-link>

                                <ul v-if="child2.children" class="dropdown-menu border-0 shadow">

                                    <li v-for="child3 in child2.children" :key="child3.id" class="dropdown-submenu">

                                        <inertia-link :href="this.route('products',{id:child3.id})" class="dropdown-item">
                                        {{child3.category_name}}
                                        </inertia-link>


                                    </li>
                                </ul>

                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
      </ul>
    </div>
</nav>

</div>
   
</template>
<script>

    export default {
        mounted(){
           $("ul.dropdown-menu [data-toggle='dropdown']").on("click", function(event) {
                event.preventDefault();
                event.stopPropagation();

                $(this).siblings().toggleClass("show");


                if (!$(this).next().hasClass('show')) {
                $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
                }
                $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
                $('.dropdown-submenu .show').removeClass("show");
                });

            });
        }
    }
</script>  